module.exports = __webpack_public_path__ + "static/media/Delve.91f386e1.png";